import React, { useState,useEffect } from 'react'
import { EditePageApi, getPageDetailApi } from '../../API/AdminServices'
import Button from '../../Components/Button/Button'
import Editor from '../../Components/Editor/Editor'
import { errorToast, succToast } from '../../Toast/Toast'
import Style from './EditPage.module.css'
const EditPage = () => {

    const[pageDetail,setPageDetail]=useState()
    const[description,setDescription]=useState('')
    useEffect(()=>{
        getPageDetail()
    },[])
    const getPageDetail=async()=>{
        const data=await getPageDetailApi(window.location.pathname.split('/')[2])
        setPageDetail(data.page)
        setDescription(data.page.content)
    }
    const EditPageHandler=()=>{
        if(description===''){
            errorToast('لطفا محتوایی به صفحه اضافه کنید!')
        }
        else{
            let info={
                page:window.location.pathname.split('/')[2],
                content:description
            }
            EditePageApi(info,(succ)=>{
                if(succ.status===1){
                    succToast(succ.message)
                }
                else{
                    errorToast(succ.message)
                }
            })
        }
    }
    return (
        <div className={Style.PageHolder}>
            <div className={Style.Pageinfo}>
                <a href={pageDetail&&`https://electronicsteps.ir/${pageDetail.page}`} rel='noreferrer' target="_blank" >{pageDetail===undefined?'درحال دریافت' :`www.electronicsteps.ir/${pageDetail.page}`}</a>
                <h3>{pageDetail===undefined?'درحال دریافت':pageDetail.title}</h3>
            </div>
            <Editor
            desc={description}
            setdescription={setDescription}

            />
            <Button Value={'ویرایش'} ClassBtn={'confirmBtn'} clickhandler={EditPageHandler}/>
        </div>
    )
}

export default EditPage
